import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { FeatureGroup } from "leaflet";
import { MapStation } from "../../../core/models";
import { LanguageService } from "../../../core/services";
import { StationMarkerBuilder } from "../builders";

export class StopsLayerService {
  private readonly langService: LanguageService;
  readonly stopsLayer = new FeatureGroup;
  private stops: MapStation[] = [];
  private router!: Router;
  private highlightedId: string | null = null;  

  constructor() {
    this.langService = inject(LanguageService);
  }

  init(router: Router) {
    this.router = router;
  }

  highlightStop(id: string, end: boolean = false): void {
    this.stopsLayer.eachLayer(l => {
      const o = l.options as any;
      if (o.stopId == id) {
        if (end) {
          l.fireEvent('mouseleave');
          this.highlightedId = null;
        }
        else {
          l.fireEvent('mouseover');
          this.highlightedId = id;
        }
      }
    });
  }

  redraw(stops: MapStation[]) {
    this.stops = stops;
    this.stopsLayer.clearLayers();
    this.addStops();
  }

  private addStops() {
    this.stops.forEach(stop => {
      if (stop.lat && stop.lon) {
        const marker = StationMarkerBuilder.buildMarker(stop, this.langService);
        marker.on('click', () => this.router.navigate([`departures/${stop.id}`]));
        this.stopsLayer.addLayer(marker);
        if (this.highlightedId && stop.id == this.highlightedId) {
          marker.openPopup();
        }
      }
    });
  }
}
